import Main from '@/components/main'
import config from '../../static/config'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */
export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/monitor_split_screen',
    name: 'monitor_split_screen',
    component: ()=> import('@/view/monitor/monitor.vue')
  },
  {
    path: '/station_split_screen',
    name: 'station_split_screen',
    component: ()=> import('@/view/station/station.vue')
  },
  {
    path: '/alarm_split_screen',
    name: 'alarm_split_screen',
    component: ()=> import('@/view/monitor/alarm-video')
  },{
    path: '/surveillance_split_screen',
    name: 'surveillance_split_screen',
    component: ()=> import('@/view/surveillance/surveillance.vue')
  },
  {
    path: '/',
    name: '_home',
    redirect: '/login',
    component: Main,
    children: [
      {
        path: '/cascade',
        name: 'cascade',
        component: () => import('@/view/cascade/cascade.vue')
      },
      {
        path: '/dispatch',
        name:'dispatch',
        component:()=>import('@/view/dispatch/dispatch.vue')
      },
      {
        path: '/control',
        name: 'control',
        component: () => import('@/view/control/control.vue')
      },
      {
        path: '/conference',
        name: 'conference',
        component: () => import('@/view/conference/conference.vue')
      },
      {
        path: '/broadcast',
        name: 'broadcast',
        component: () => import('@/view/broadcast/broadcast.vue')
      },
      {
        path: '/unattended',
        name: 'unattended',
        component: ()=> import('@/view/unattended/unattended.vue')
      },
      {
        path: '/alarm',
        name: 'alarm',
        component: ()=> import('@/view/alarm/alarm.vue')
      },
      {
        path: '/monitor',
        name: 'monitor',
        component: ()=> import('@/view/monitor/monitor.vue')
      },
      {
        path: '/station',
        name: 'station',
        component: ()=> import('@/view/station/station.vue')
      },
      {
        path: '/action_plan',
        name: 'action_plan',
        component: ()=> import('@/view/action_plan/action_plan.vue')
      },
      {
        path: '/notice',
        name: 'notice',
        component: ()=> import('@/view/notice/notice.vue')
      },
      {
        path: '/linkman',
        name: 'linkman',
        component: () => import('@/view/linkman/linkman.vue')
      },
      {
        path: '/reporting_information',
        name: 'reporting_information',
        component: ()=> import('@/view/reporting_information/reporting_information.vue')
      },
      {
        path: '/self_check',
        name: 'self_check',
        component: () => import('@/view/self_check/selfCheck.vue')
      },
      {
        path: '/sys',
        name:'System manage',
        meta: {
          title:'management',
          href: config.sysUrl
        }
      },
      {
        path: '/hourly_chime',
        name: 'hourly_chime',
        component: () => import('@/view/hourlyChime/hourlyChime.vue')
      },
      {
        path: '/chatChannel',
        name: 'chatChannel',
        component: () => import('@/view/chat/chat.vue')
      },
      {
        path: '/video_surveillance',
        name: 'video_surveillance',
        component: () => import('@/view/surveillance/surveillance.vue')
      },
      {
        path: '/report',
        name: 'report',
        component: () => import('@/view/report/report.vue')
      }
    ]
  },
  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true,
    },
    component: () => import('@/view/error-page/500.vue')
  },
  {
    path: '*',
    name: 'error_404',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/404.vue')
  },
  {
    path: '/unattended_black',
    name: 'stand_page',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/unattended/stand.vue')
  }
];



// WEBPACK FOOTER //
// ./src/router/routers.js